import AgendaItemMinutes from './AgendaItemMinutes';

export default AgendaItemMinutes;